const type = 'CLOSE_CARD_EDIT_PARAM';

const closeCardEditParam = () => ({
  type,
});

export { type };
export default closeCardEditParam;
